import { bool, func, string } from 'prop-types';
import React from 'react';
import { GoTrashcan } from 'react-icons/go';
import { Button } from 'reactstrap';

const RemoveButton = ({ className, id, onClick, disabled, ...rest }) => (
  <Button
    id={id}
    className={className}
    type="button"
    onClick={onClick}
    disabled={disabled}
    outline
    {...rest}
  >
    <GoTrashcan />
  </Button>
);

RemoveButton.propTypes = {
  className: string,
  id: string.isRequired,
  onClick: func,
  disabled: bool,
};

RemoveButton.defaultProps = {
  className: undefined,
  disabled: false,
  onClick() {},
};

export default RemoveButton;
